module.exports = __webpack_public_path__ + "img/conecte.1201f9a5.svg";